
seedWebApp.controller('UsersInvitationsCtrl', ['$scope', 'UserSettingService', 'ToastService', function ($scope, UserSettingService, ToastService) {

    var vm = this;

    vm.closeDetail = closeDetail;
    vm.inviteUserAgain = inviteUserAgain;
    vm.isDetail = false;
    vm.loading = false;
    vm.loadingDetail = false;
    vm.reload = reload;
    vm.selectUser = selectUser;
    vm.users = [];
    vm.userSelected = null;

    getUsers();

    vm.getStatus = function (inv) {
        if (inv.Used)
            return 'Convite Utilizado';

        if (inv.Expired)
            return 'Convite Expirado';

        return 'Convite Não Utilizado';
    };

    vm.invitationClass = function (inv) {
        if (inv.Used)
            return 'used';
        else {
            if (inv.Expired)
                return 'expired';
            return 'not-used';

        }
    };

    //Fecha detalhe
    function closeDetail() {
        vm.isDetail = false;
        vm.userSelected = null;
    }

    //Busca usuários
    function getUsers() {
        vm.loading = true;
        UserSettingService.getInvitations()
            .then(function (res) {
                vm.users = res.data;
                vm.loading = false;
            })
            .catch(function (err) {
                console.error(err);
            });
    }

    //Envia convite para usuário
    function inviteUserAgain(userID) {

        var params = {
            id: userID,
            actionTag: 'inviteUser'
        }

        var toast = ToastService.createToast('Reenviando convite', 'Aguarde um momento...', 0, 'wait');
        UserSettingService.action(params,
            function (res) {
                ToastService.removeToast(toast);
                ToastService.createToast('Sucesso', 'Convite reenviado com sucesso!', 5000, 'success');
            },
            function (err) {
                console.error(err);
            });
    }

    //Recarrega usuários
    function reload() {
        UserSettingService.resetCache();
        vm.users = [];
        getUsers();
    }

    //Seleciona usuário
    function selectUser(user) {
        vm.isDetail = true;
        vm.userSelected = user;
    }

    $(document).ready(function () {
        vm.overflowSize = $scope.AdjustSize() -150;
    });

}]);
